import { render } from "./CompanyRoles.vue?vue&type=template&id=1b53abf0"
import script from "./CompanyRoles.vue?vue&type=script&lang=js"
export * from "./CompanyRoles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__